import React from 'react';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import { genreList } from '../../../resources/base/models';
import { pickOptionsValue } from '../../../services/common/miscUtils';
import { customSelectors } from '../../../services/redux/features/custom.slice';
import { VehicleConfigData } from '../../../types';
import { ConfigVehicleFinancial } from './configVehicleFinancial';

interface StepProps {
  onSubmit: (values: VehicleConfigData) => void;
}

export function Step({ onSubmit }: StepProps) {
  const vehicleType = useSelector(customSelectors.selectVehicleType);

  const initialValues = {
    vehicleType,
    genreList: pickOptionsValue(genreList, 'DVP'),
  } as unknown as VehicleConfigData;

  return (
    <Formik enableReinitialize initialValues={initialValues} onSubmit={onSubmit}>
      <ConfigVehicleFinancial />
    </Formik>
  );
}
